import axios from "axios";
import { host } from "../../../helper/config";

const PLUGINS_NAME = "admin-classic-setting";

export const getClassicRegionSetting = async (token) => {
  const response = await axios.post(
    `${host}/${PLUGINS_NAME}/region/get`,
    {},
    {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Authorization: token,
      },
    },
  );

  if (response && response.status === 200) {
    return response.data || {};
  }
  return {};
};

export const updateClassicRegionSetting = async (token, config) => {
  const response = await axios.post(
    `${host}/${PLUGINS_NAME}/region/update`,
    config,
    {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Authorization: token,
      },
    },
  );

  if (response && response.status === 200) {
    return response.data || {};
  }
  return {};
};
